import {axios as http} from "@/plugins/http"

export default class Api {
    static changePublished(postId) {
        return http.post('/api/v1/post/change-published', {
            post_id: postId,
        })
    }
}
